export var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus[CompanyStatus["Active"] = 1] = "Active";
    CompanyStatus[CompanyStatus["Duplicate"] = 2] = "Duplicate";
    CompanyStatus[CompanyStatus["Block"] = 3] = "Block";
    CompanyStatus[CompanyStatus["MissingInfo"] = 4] = "MissingInfo";
})(CompanyStatus || (CompanyStatus = {}));
